import { QueryKeys } from "@Constants";
import SessionManager from "@Core/session";
import { IComplianceMeta } from "@Models/IComplianceDetails";
import ComplianceService from "@Services/ComplianceService";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useFlagAsInappropriate = (userId = SessionManager.getServiceUser().userId) => {
    const complianceService = new ComplianceService();
    const queryClient = useQueryClient();
    return useMutation(
        async ({ model }: { model: IComplianceMeta }) => await complianceService.create(userId, "flagged", model),
        {
            onSuccess: async (res) => {
                if (res?.value?.id) {
                    await queryClient.invalidateQueries([QueryKeys.Compliance]);
                }
            },
        }
    );
};
